export const ORDER_PROCESSING = 'order/ORDER_PROCESSING';
export const DELIVERY_DATES_LOAD = 'order/DELIVERY_DATES_LOAD';
export const SET_DELIVERY_DAY_OFFSET = 'order/SET_DELIVERY_DAY_OFFSET';
export const SET_DELIVERY_OUTLET = 'order/SET_DELIVERY_OUTLET';
export const SET_COMMENT = 'order/SET_COMMENT';
export const LOAD_ORDER_HISTORY = 'order/LOAD_ORDER_HISTORY';
export const SET_LOADING_ORDER_HISTORY = 'order/SET_LOADING_ORDER_HISTORY';
